<script lang="ts">
  import {SqrlQaId} from "../../constants/squirrel";
  import {isModified, value} from "../../store/SearchfieldStore";
  import {indexStore} from "../../store/IndexStore";
  import {tracking} from "../../tracking/Tracking";
  import {tlSuggestAdoptPosition} from "../../tracking/labels/SuggestAdoptPosition";
  import {tlSuggestAdoptTerm} from "../../tracking/labels/SuggestAdoptTerm";
  import {createEventDispatcher} from 'svelte'

  export let term: string;
  export let index: number;
  let dispatch = createEventDispatcher();

  function changeSearchTerm(event: Event) {
    if (event instanceof KeyboardEvent && event.key !== "Enter") {
      return;
    }
    $isModified = true;
    indexStore.reset();
    $value = `${term} `;
    /*                                                                                                     */
    const inputElement: HTMLInputElement | null = document.querySelector(".js_squirrel_searchbar__input");
    inputElement?.focus();
    dispatch('sendRequest', {term: $value})
    tlSuggestAdoptPosition.value = index + 1;
    tlSuggestAdoptTerm.value = $value;
    tracking.trackSubmitEvent({...tlSuggestAdoptPosition.data, ...tlSuggestAdoptTerm.data});
  }
</script>

<div
        class="squirrel_searchSuggest__arrow js_squirrel_searchSuggest__arrow squirrel_searchSuggest__right-icon"
        data-qa-id={SqrlQaId.MODIFIED_ARROW}
        data-testid={SqrlQaId.MODIFIED_ARROW}
        on:click|preventDefault={changeSearchTerm}
        on:keydown|preventDefault={changeSearchTerm}
        role="button"
>
    <svg class="pl_icon" role="img">
        <use xlink:href="/assets-static/icons/pl_icon_search-enter.svg#pl_icon_search-enter"></use>
    </svg>
</div>

<style lang="scss">
  @use "~@otto-ec/global-frontend-settings/scss/pl_variables" as pl_variables;

  .squirrel_searchSuggest__arrow {
    color: #000;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    top: 0;
    right: 0;
    padding: 12px 16px;

    svg {
      fill: pl_variables.$pl_color-red100;
      height: 24px;
      width: 24px;
    }
  }
</style>
